import React from "react";
import { Form } from "react-bootstrap";
import { parseStretch } from "../../../model/millingStretch";
import MillingImage from "./MillingImage";
import MillingRepeatSettings from "./MillingRepeatSettings";

function StretchPreview({ value }) {
  let profile;
  try { profile = parseStretch(value); } catch (_) { return null; }
  return <svg viewBox="0 0 100 8" aria-hidden="true" style={{ width: "100%", height: 16 }}>
    <path d="M0 4H100" stroke="#aaa" strokeWidth="0.5" />
    {profile.interval || profile.intervals ? (profile.intervals || [profile.interval]).map(([a,b])=><rect key={a} x={a * 100} y="1"
      width={(b-a) * 100} height="6" fill="#0d6efd" opacity="0.3" />)
      : profile.points.map((p) => <path key={p} d={`M${p * 100} 0V8`} stroke="#0d6efd" strokeWidth="1" />)}
  </svg>;
}

export function StretchSettings({ value, onChange }) {
  return <fieldset className="border rounded p-2 my-2">
    <legend className="float-none w-auto fs-6">Nyújtási helyek</legend>
    {(value.imageKey || value.file) && <div className="mb-3">
      <MillingImage imageKey={value.imageKey} file={value.file} name={value.name || "Nyújtási előnézet"} stretch={value} />
      <div className="small mt-1">
        <span style={{ color: "#007bff" }}>Kék: vízszintes nyújtás</span>{" · "}
        <span style={{ color: "#b85300" }}>Narancs: függőleges nyújtás</span>
        <span className="text-muted"> · Vonal: nyújtási pont; sáv: nyújtási intervallum.</span>
        {(value.repeatX || value.repeatY) && <div><span style={{ color: "#15803d" }}>Zöld: másolandó mintaszakasz</span>{" · "}
          <span style={{ color: "#9333ea" }}>Lila: ismétlési tartomány és középvonala</span></div>}
      </div>
    </div>}
    <div className="d-flex gap-3 flex-wrap">
      {[["stretchX", "Vízszintes — bal széltől (%)"], ["stretchY", "Függőleges — alsó széltől (%)"]].map(([key, label]) =>
        <Form.Group key={key}>
          <Form.Label>{label}</Form.Label>
          <Form.Control aria-label={label} value={value[key] || ""} placeholder="50" disabled={!!value[key === "stretchX" ? "repeatX" : "repeatY"]}
            maxLength={255} onChange={(e) => onChange({ ...value, [key]: e.target.value })} />
          {!value[key === "stretchX" ? "repeatX" : "repeatY"] && <StretchPreview value={value[key]} />}
        </Form.Group>)}
    </div>
    <MillingRepeatSettings value={value} onChange={onChange} />
    <p className="small text-muted">Több nyújtási intervallum: 10:30;70:90. A méretváltozás egyenlően oszlik el az intervallumok között, a köztes részek mérete megmarad.</p>
    <small className="text-muted">Üresen: felezővonal. Egy pont: 50; két pont: 25,75; intervallum: 25:75.
      A helyeket az eredeti kép/DXF méretének százalékában add meg, tizedesponttal.
      Több pontnál a méretváltozás egyenlően oszlik el. Az intervallum egyenletesen nyúlik, a többi rész mérete megmarad.</small>
  </fieldset>;
}

export default function MillingVariantSettings({ value, onChange }) {
  const mode = value.selectionMode || "manual";
  return <>
    <div className="d-flex gap-3 flex-wrap my-2">
      <Form.Group><Form.Label>Változat használata</Form.Label>
        <Form.Select aria-label="Változat használata" value={mode}
          onChange={(e) => onChange({ ...value, selectionMode: e.target.value, minSizeMm: null, maxSizeMm: null })}>
          <option value="manual">Kézzel választható (pl. ráma)</option>
          <option value="width">Automatikus — szélesség alapján</option>
          <option value="height">Automatikus — magasság alapján</option>
        </Form.Select>
      </Form.Group>
      {mode !== "manual" && [["minSizeMm", "Alsó határ (mm, beleértve)"], ["maxSizeMm", "Felső határ (mm, nem beleértve)"]].map(([key, label]) =>
        <Form.Group key={key}><Form.Label>{label}</Form.Label>
          <Form.Control type="number" min="0" max="10000" step="any" aria-label={label}
            placeholder="Nincs határ" value={value[key] ?? ""}
            onChange={(e) => onChange({ ...value, [key]: e.target.value === "" ? null : Number(e.target.value) })} />
        </Form.Group>)}
    </div>
    {mode !== "manual" && <p className="small text-muted">Például felső határ: 150 → csak 150 mm alatt.
      A szélességi szabály elsőbbséget élvez a magasságival szemben. Azonos iránynál az első illeszkedő változat nyer.
      Az automatikus változat nem választható kézzel.</p>}
    <StretchSettings value={value} onChange={onChange} />
  </>;
}
